import { useQuery } from '@tanstack/react-query'

import { PositionBalance } from '~/components/smart-accounts/positions/types'
import { QUERY_KEYS } from '~/constants/react-query'
import { useServerRequests } from '~/hooks/useRequests'
import { BackendTransactionCall } from '~/types'
import { EvmAddress } from '~/utils/address'

export const usePositionCallsToClaim = (positionBalance: PositionBalance) => {
  const { serverGetRequest } = useServerRequests()

  return useQuery<BackendTransactionCall[]>({
    queryKey: [QUERY_KEYS.POSITION_CALLS_TO_CLAIM, positionBalance.id],
    enabled: !!positionBalance.id,
    queryFn: async () => {
      const response = await serverGetRequest<{
        calls: { to: EvmAddress.Type; value: string; data: string }[]
      }>({
        path: `/api/positions/claim/${positionBalance.id}`,
      })

      if (!response) {
        throw new Error('Failed to fetch calls to claim')
      }

      return response.data.calls.map((call) => {
        return {
          to: call.to,
          value: BigInt(call.value),
          data: call.data,
        }
      })
    },
  })
}
